import { useQuery } from '@tanstack/react-query';
import { gitApi } from '../api/gitApi';

export function useGitServers() {
  return useQuery({
    queryKey: ['gitServers'],
    queryFn: () => gitApi.listServers(),
  });
}
